<template>
  <div class="sidebar">
    <div class="logo">
      <el-image :src="logoSrc" alt="" class="logo-icon" />
    </div>

    <div class="menu-list">
      <div v-for="item in menuItems" :key="item.name">
        <!-- 主菜单项 -->
        <div
          v-if="!item.children"
          :class="['menu-item', { active: activeMenu === item.name }]"
          @click="handleMenuClick(item.name)"
        >
          <el-image :src="item.icon" class="menu-icon"></el-image>
          <span>{{ item.label }}</span>
        </div>

        <!-- 有子菜单的项 -->
        <div v-else class="menu-with-children">
          <div
            :class="['menu-item', { active: isParentActive(item.name) }]"
            @click="toggleSubmenuMultiple(item)"
          >
            <el-image :src="item.icon" class="menu-icon"></el-image>
            <span>{{ item.label }}</span>
            <el-image
              :src="expandedMenus.includes(item.name) ? arrowUp : arrowDown"
              class="arrow"
            />
          </div>

          <!-- 子菜单展开面板 -->
          <transition name="submenu">
            <div
              v-show="expandedMenus.includes(item.name)"
              class="submenu-panel"
            >
              <div
                v-for="child in item.childrenList"
                :key="child.name"
                :class="['submenu-item', { active: activeMenu === child.name }]"
                @click="handleMenuClick(child.name)"
              >
                <span>{{ child.label }}</span>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <!-- <div class="sidebar-footer">
      <PrimaryButton class="btn-points" @click="handleJifenClick">
        <el-image :src="jfIcon" class="jf-icon"></el-image>
        <span>积分购买</span>
      </PrimaryButton>
      <el-popover placement="top" width="240" trigger="click">
        <div>555</div>
        <div class="user-info" slot="reference">
          <el-image :src="avatar" class="avatar" />
          <div class="user-text">
            <p class="username">JasonAnx</p>
            <p class="userid">13856781234</p>
          </div>
        </div>
      </el-popover>
    </div> -->

    <div class="sidebar-footer">
      <PrimaryButton class="btn-points" @click="handleJifenClick">
        <el-image :src="jfIcon" class="jf-icon"></el-image>
        <span>积分购买</span>
      </PrimaryButton>

      <!-- 积分购买弹窗 -->
      <MyPointDialog
        :visible.sync="pointsDialogVisible"
        @close="handlePointsRefresh"
      />

      <!-- 用户信息区域 -->
      <el-popover
        placement="top"
        width="240"
        trigger="click"
        popper-class="user-popover"
        v-model="popoverVisible"
      >
        <!-- 弹出内容 -->
        <div class="popover-content">
          <!-- 贷款余额 -->
          <div class="popover-item">
            <el-image :src="loanIcon" class="item-icon" />
            <div class="item-text">
              <p class="item-label">货款余额（元）</p>
              <div style="display: flex; align-items: baseline">
                <p class="symbol">￥</p>
                <p class="item-value">{{ creditBalance.toFixed(2) }}</p>
              </div>
            </div>
          </div>

          <!-- 积分 -->
          <div class="popover-item">
            <el-image :src="pointsIcon" class="item-icon" />
            <div class="item-text">
              <p class="item-label">积分</p>
              <p class="item-value">{{ userPoints }}</p>
            </div>
          </div>

          <!-- 分隔线 -->
          <div class="divider"></div>

          <!-- 菜单项 -->
          <div class="popmenu-list">
            <div class="popmenu-item" @click="handleMenuItemClick('feiyon')">
              <span>费用中心</span>
            </div>
            <div
              class="popmenu-item"
              @click="handleMenuItemClick('vip-upgrade')"
            >
              <span>升级会员</span>
            </div>
            <div class="popmenu-item" @click="handleMenuItemClick('quick-start')">
              <span>快速入门</span>
            </div>
            <div
              class="popmenu-item"
              @click="handleMenuItemClick('change-password')"
            >
              <span>修改密码</span>
            </div>
            <div
              class="popmenu-item logout"
              @click="handleMenuItemClick('logout')"
            >
              <div class="logout-item">
                <img
                  src="../../../src/assets/images/newui/logoutIcon@2x.png"
                  alt=""
                />
                <span>退出登录</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 触发按钮 -->
        <div class="user-info" slot="reference">
          <div class="avatar-container">
            <el-image :src="avatar" fit="cover" class="avatar" />
            <el-image :src="avatarFrame" class="avatar-frame" />
          </div>
          <div class="user-info-content">
            <div class="user-text">
              <p class="username">{{ userInfo.nickname }}</p>
              <p class="userid">{{ userInfo.phone }}</p>
            </div>
            <el-image :src="vipTagImage" class="vip-tag" />
          </div>
        </div>
      </el-popover>
    </div>

    <VipUpgradeDialog :visible.sync="vipDialogVisible" @upgrade="handleUpgrade"/>
    <CustomerQRDialog :visible.sync="customerQRVisible"/>
  </div>
</template>

<script>
import avatar from "@/assets/images/pic-avatar.png";
import vip1Frame from "@/assets/images/newui/pic-avatar-vip1.png";
import vip2Frame from "@/assets/images/newui/pic-avatar-vip2.png";
import vip3Frame from "@/assets/images/newui/pic-avatar-vip3.png";
import vip1Tag from "@/assets/images/newui/pic-tag-vip1.png";
import vip2Tag from "@/assets/images/newui/pic-tag-vip2.png";
import vip3Tag from "@/assets/images/newui/pic-tag-vip3.png";
import arrowDown from "@/assets/images/newui/arrow-down.png";
import arrowUp from "@/assets/images/newui/arrow-up.png";
import jfIcon from "@/assets/images/newui/jfIcon@2x.png";
import icon1 from "@/assets/images/newui/Icon1@2x.png";
import icon2 from "@/assets/images/newui/icon2@2x.png";
import icon3 from "@/assets/images/newui/icon3@2x.png";
import icon4 from "@/assets/images/newui/icon4@2x.png";
import icon5 from "@/assets/images/newui/icon5@2x.png";
import icon6 from "@/assets/images/newui/icon6@2x.png";
import icon7 from "@/assets/images/newui/icon7@2x.png";
import icon8 from "@/assets/images/newui/icon8@2x.png";
import icon9 from "@/assets/images/newui/icon9@2x.png";
import icon10 from "@/assets/images/newui/icon10@2x.png";
import loanIcon from "@/assets/images/newui/czicon@2x.png";
import pointsIcon from "@/assets/images/newui/jfIcon@2x.png";
import MyPointDialog from "@/components/myPointDialog/index.vue";
import { mapGetters } from "vuex";
import { requestCustomerConfig } from "@/api/home";
import { requestPointsProductList } from "@/api/merchant";
import { requestTutorialUrl } from '@/api/staff';
import VipUpgradeDialog from "@/components/VipUpgradeDialog/index.vue";
import CustomerQRDialog from "@/components/CustomerQRDialog/index.vue";

export default {
  components: {
    MyPointDialog,
    VipUpgradeDialog,
    CustomerQRDialog,
  },
  data() {
    return {
      avatar,
      arrowDown,
      arrowUp,
      jfIcon,
      icon1,
      icon2,
      icon3,
      icon4,
      icon5,
      icon6,
      icon7,
      icon8,
      icon9,
      icon10,
      loanIcon,
      pointsIcon,
      vip1Frame,
      vip2Frame,
      vip3Frame,
      vip1Tag,
      vip2Tag,
      vip3Tag,
      activeMenu: "home",
      expandedMenus: [], // 存储展开的子菜单
      pointsDialogVisible: false, // 积分购买弹窗显示状态
      menuItems: [
        {
          label: "工作台",
          name: "workbench-index",
          icon: icon1,
        },
        {
          label: "资源中心",
          name: "design",
          icon: icon2,
          children: true,
          childrenList: [
            { label: "选品广场", name: "plaza-index" },
            { label: "AI图库", name: "gallery-index" },
            { label: "我的图库", name: "design-index" },
          ],
        },
        { label: "AI工具箱", name: "tool-index", icon: icon3 },
        {
          label: "自动化上架", name: "plat-index", icon: icon4,
          children: true,
          childrenList: [
            { label: "工作流", name: "plat-index" },
            { label: "商品汇出", name: "img-output" },
          ],
         },
        { label: "产品管理", name: "product-index", icon: icon5 },
        // { label: "视频合成", name: "ai-prompt", icon: icon6 },
        {
          label: "店铺运营", name: "img-output", icon: icon10,
          children: true,
          childrenList: [
            { label: "店铺授权", name: "store-index" },
            { label: "商品模板", name: "templateManage" },
            { label: "样机管理", name: "demoManage" },
          ],
         },
        { label: "订单管理", name: "order-index", icon: icon8 },
        {
          label: "系统管理",
          name: "WorkflowTemplate",
          icon: icon9,
          children: true,
          childrenList: [
            // { label: "用户管理", name: "user-management" },
            // { label: "角色管理", name: "role-management" },
            // { label: "权限管理", name: "permission-management" },
            { label: "资产管理", name: "asset-index" },
            { label: "员工管理", name: "employee-index" },
          ],
        },
      ],
      popoverVisible: false,
      creditBalance: 0, // 贷款余额
      //vip 弹窗
      vipDialogVisible: false,
      //客服二维码弹窗
      customerQRVisible: false,
    };
  },

  mounted() {
    // 初始化时根据当前路由展开对应的子菜单
    this.initExpandedMenus();
    // 加载贷款余额
    this.loadCreditBalance();
    // 获取入门链接
    this.requestTutorialUrl();
    // 获取客服配置
    this.getCustomerConfig();
  },

  watch: {
    // 监听路由变化，更新激活菜单
    $route(to) {
      const routeName = to.name;
      this.activeMenu = routeName;

      // 如果当前路由是子菜单项，确保父菜单展开
      this.ensureParentMenuExpanded(routeName);
    },
  },

  methods: {
    // 初始化展开的子菜单
    initExpandedMenus() {
      const currentRoute = this.$route.name;
      if (currentRoute) {
        this.ensureParentMenuExpanded(currentRoute);
      }
    },

    // 切换子菜单展开/收起（互斥展开，同时只允许一个父菜单展开）
    toggleSubmenu(item) {
      const index = this.expandedMenus.indexOf(item.name);

      if (index > -1) {
        // 已展开，则收起
        this.expandedMenus.splice(index, 1);
      } else {
        // 未展开，则展开，并收起其他所有菜单
        this.expandedMenus = [item.name];
      }
    },

    // 切换子菜单展开/收起（支持多个展开）
    toggleSubmenuMultiple(item) {
      const index = this.expandedMenus.indexOf(item.name);

      if (index > -1) {
        // 已展开，则收起
        this.expandedMenus.splice(index, 1);
      } else {
        // 未展开，则展开
        this.expandedMenus.push(item.name);
      }
    },

    // 处理菜单项点击
    handleMenuClick(name) {
      
      this.activeMenu = name;
      this.$emit("menuClick", name);

      // 根据路由名称进行跳转
      this.$router.push({ name: name }).catch((err) => {
              });
    },

    // 检查父菜单是否激活（有子菜单被激活）
    isParentActive(parentName) {
      const parentItem = this.menuItems.find(
        (item) => item.name === parentName,
      );
      if (!parentItem || !parentItem.childrenList) {
        return false;
      }

      return parentItem.childrenList.some(
        (child) => child.name === this.activeMenu,
      );
    },

    // 确保父菜单展开（当子菜单被激活时）
    ensureParentMenuExpanded(routeName) {
      for (const item of this.menuItems) {
        if (item.childrenList) {
          const hasActiveChild = item.childrenList.some(
            (child) => child.name === routeName,
          );
          if (hasActiveChild) {
            // 只展开包含当前路由的父菜单
            if (!this.expandedMenus.includes(item.name)) {
              this.expandedMenus.push(item.name);
            }
            break;
          }
        }
      }
    },

    // 获取菜单的路由路径
    getMenuRoute(name) {
      // 这里可以根据实际路由配置映射菜单名称到路径
      const routeMap = {
        home: "/home",
        "plaza-index": "/plaza/plaza-index",
        "gallery-index": "/gallery/gallery-index",
        gallery: "/gallery",
        "tool-index": "/aitools/tool-index",
        "plat-index": "/plat/plat-index",
        "product-index": "/product/product-index",
        "ai-prompt": "/plat/ai-prompt",
        "ai-derivation": "/plat/ai-derivation",
        "ai-title": "/plat/ai-title",
        "user-management": "/settings/user-management",
        "role-management": "/settings/role-management",
        "permission-management": "/settings/permission-management",
        "img-output": "/plat/imgOutput",
        "store-index": "/storeManage/store-index",
        "templateManage": "/plat/templateManage/index",
        "demoManage": "/mockupManage/demoManage",
      };

      return routeMap[name] || `/${name}`;
    },

    // 处理积分购买点击
    handleJifenClick() {
      this.pointsDialogVisible = true;
    },

    // 积分购买刷新回调
    handlePointsRefresh() {
      // this.$message.success("积分充值成功");
      this.pointsDialogVisible = false;
      // 重新加载余额数据
      this.loadCreditBalance();
    },

    // 加载贷款余额
    async loadCreditBalance() {
      try {
        const response = await requestPointsProductList({});
        if (response && response.data) {
          this.creditBalance = response.data.currentBalance || 0;
          // 更新 Vuex 中的积分
          this.$store.dispatch("fetchUserPoints");
        }
      } catch (error) {
        console.error("加载货款余额失败:", error);
      }
    },

    async requestTutorialUrl() {
      try {
        const res = await requestTutorialUrl();
        const url = res && res.data && res.data.tutorialUrl;
        this.$store.dispatch('SetTutorialUrl', url || '');
      } catch (error) {
        console.error('获取入门链接失败:', error);
      }
    },

    getCustomerConfig() {
      try {
        requestCustomerConfig().then(({ data }) => {
          this.$store.dispatch('SetCustomerConfig', data);
        });
      } catch (error) {
        console.error('获取客服配置失败:', error);
      }
    },

    handleUpgrade(type) {
      // this.vipDialogVisible = false;
      this.customerQRVisible = true;
    },

    handleMenuItemClick(action) {
      switch (action) {
        case "change-password":
          this.$router.push("/change-password/changePassword-index");
          break;
        case "logout":
          this.$confirm("确定要退出登录吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$store.dispatch("LogOut").then(() => {
              this.$router.push("/login");
            });
          });
          break;
        case "feiyon":
          // 跳转到资产管理
          if (this.$route.name !== "asset-index") {
            this.$router.push("/asset/asset-index");
          }
          // 关闭popover
          this.popoverVisible = false;
          break;
        case "vip-upgrade":
          this.vipDialogVisible = true;
          this.popoverVisible = false;
          break;
        case "quick-start":
          if (this.tutorialUrl) {
            this.$router.push("/quick-start/quickStart-index");
          }
          break;
        default:
          break;
      }
    },
  },
  computed: {
    ...mapGetters(["userPoints", "userInfo", "tutorialUrl", "customerConfig"]),
    isKA(){
      return this.$store.getters.userInfo.isKA;
    },
    logoSrc() {
      return this.isKA ? this.$store.getters.userInfo.logoUrl : require("@/assets/images/newui/logo-nav.png");
    },
    avatarFrame() {
      const levelId = this.userInfo.levelId;
      if (levelId === 2) return this.vip2Frame;
      if (levelId === 3) return this.vip3Frame;
      return this.vip1Frame;
    },
    vipTagImage() {
      const levelId = this.userInfo.levelId;
      if (levelId === 2) return this.vip2Tag;
      if (levelId === 3) return this.vip3Tag;
      return this.vip1Tag;
    }
  },
};
</script>

<style scoped lang="scss">
.sidebar {
  height: calc(100vh - 20px);
  width: 220px;
  background: #fff;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #f0f0f0;
  background: #ffffff;
  box-shadow: 0px 5px 20px 0px rgba(53, 65, 105, 0.05);
  border-radius: 16px;
}
.logo {
  padding: 20px;
  font-weight: bold;
  color: #0084ff;
  text-align: center;
  .logo-icon {
    width: auto;
    height: 36px;
  }
}
.menu-list {
  flex: 1;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }
}
.menu-item {
  padding: 12px 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-left: 3px solid #ffffff;
  gap: 17px;
  .menu-icon {
    width: 24px;
    height: 24px;
  }
}
.menu-item.active {
  background: #e6f7ff;
  color: #1890ff;
  border-left: 3px solid #1890ff;
  transition: all 0.3s;
}
.arrow {
  width: 12px;
  margin-left: auto;
}
.sidebar-footer {
  padding: 20px;
  border-top: 1px solid #f0f0f0;
}
.btn-points {
  width: 100%;
  margin-bottom: 15px;
}
.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  .avatar-container {
    position: relative;
    width: 52px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    .avatar {
      width: 38px;
      height: 38px;
      border-radius: 50%;
    }
    .avatar-frame {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 52px;
      height: 52px;
      pointer-events: none;
    }
  }
  .user-info-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .user-text {
    .username {
      font-size: 14px;
      font-weight: bold;
      margin: 0 0 4px 0;
    }
    .userid {
      font-size: 12px;
      color: #999;
      margin: 0;
    }
  }
  .vip-tag {
    width: 52px;
    height: auto;
  }
}
.jf-icon {
  width: 20px;
  height: 20px;
}

// 子菜单样式
.menu-with-children {
  .menu-item {
    position: relative;
  }

  .arrow {
    width: 12px;
    margin-left: auto;
    transition: transform 0.3s ease;
  }
}

.submenu-panel {
  background: transparent;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.submenu-item {
  padding: 12px 20px 12px 56px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-left: 3px solid #ffffff;
  position: relative;

  &:hover {
    background: #e6f7ff;
    color: #1890ff;
    border-left: 3px solid #1890ff;
  }

  &.active {
    background: #e6f7ff;
    color: #1890ff;
    border-left: 3px solid #1890ff;
    font-weight: 500;
    transition: all 0.3s;
  }
}

// 子菜单展开动画
.submenu-enter-active,
.submenu-leave-active {
  transition: all 0.3s ease;
  max-height: 300px;
  opacity: 1;
}

.submenu-enter,
.submenu-leave-to {
  max-height: 0;
  opacity: 0;
}

.user-popover {
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background: #ffffff;
}

.popover-content {
  padding: 16px 0;
}

.popover-item {
  display: flex;
  align-items: flex-start;
  padding: 12px 20px;
  cursor: default;

  &:last-child {
    border-bottom: none;
  }
}

.item-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
}

.item-text {
  flex: 1;
}

.symbol {
  font-weight: bold;
  font-size: 16px;
  color: #333333;
}

.item-label {
  font-weight: bold;
  font-size: 14px;
  color: #6d7d8a;
  margin: 0;
}

.item-value {
  font-weight: bold;
  font-size: 24px;
  color: #333333;
  margin: 0;
}

.divider {
  height: 1px;
  background: #f5f7fa;
  margin: 12px 0px;
}

.popmenu-list {
  margin-top: 12px;
}

.popmenu-item {
  padding: 10px 50px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.3s ease;

  &:hover {
    background: #e6f7ff;
    color: #1890ff;
  }
  .logout-item {
    display: flex;
    align-items: center;
    // justify-content: flex-start;
    gap: 10px;
    img {
      width: 18px;
      height: 18px;
    }
  }
}
.logout {
  padding: 10px 20px;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
}
</style>
